"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var render_1 = require("./lib/render");
var stylesheet_1 = require("./lib/stylesheet");
var check_1 = require("./lib/check");
var TEMPLATES = {
    closed: "",
    suspended: "<div class=\"Audiate AudiateSound AudiateSound--suspended\">\uD83D\uDD07</div>",
    running: "<div class=\"Audiate AudiateSound AudiateSound--running\">\uD83D\uDD0A</div>"
};
exports.ambient = function (_a) {
    var _b = (_a === void 0 ? {} : _a).stylesheet, stylesheet = _b === void 0 ? stylesheet_1.defaultStylesheet : _b;
    stylesheet_1.appendStylesheet(stylesheet);
    var initialState;
    try {
        initialState = check_1.check();
    }
    catch (error) {
        console.error(error);
        // Silently return
        return;
    }
    var indicator = render_1.render(TEMPLATES[initialState]);
    document.body.appendChild(indicator);
    // Audio is able to be played
    if (initialState === "running") {
        return;
    }
    var checkInterval;
    var unlock = function () {
        var unlockedState = check_1.check();
        if (unlockedState === "running") {
            indicator.innerHTML = TEMPLATES.running;
            document.removeEventListener("click", unlock);
            clearInterval(checkInterval);
        }
    };
    document.addEventListener("click", unlock);
    checkInterval = setInterval(function () {
        var checkedState = check_1.check();
        if (checkedState === "running") {
            indicator.innerHTML = TEMPLATES.running;
            clearInterval(checkInterval);
            document.removeEventListener("click", unlock);
        }
    }, 500);
};
